<app-create-company-location [companyId]="invoice?.company_id ?? null"></app-create-company-location>
<app-drop-down-section title="{{ 'shared.company_information' | transloco }}"
    titleIcon="assets/icons/admin/building-black.svg">
    <!-- Actions-->
    <app-edit-cancel-button header-actions [isEditing]="isEditing" (edit)="onClickEdit()"
        (cancel)="cancelEditData()" (save)="saveEditData()"></app-edit-cancel-button>

    <!-- Body -->
    <div class="flex flex-col gap-2 font-[Gilroy]">
        <div class="overflow-x-auto max-w-ultrawide w-full justify-center pb-1 mobile:max-w-screen h-full block">
            <table class="table w-full">
                <!-- Header -->
                <thead class="bg-neutral-100 text-neutral-700 uppercase">
                    <tr class="max-h-[50px]">
                        <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.description' |
                            transloco
                            }}</th>
                        <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.extraction' |
                            transloco
                            }}</th>
                    </tr>
                </thead>
                <!-- Content -->
                <tbody>
                    <!-- Company name -->
                    <tr class="max-h-[50px]">
                        <td class="border-b border-border px-4 py-4">
                            {{ 'admin.company_name' | transloco }}
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            {{ this.invoice?.company?.name || '' }}
                        </td>
                    </tr>

                    <!-- Industry code -->
                    <tr class="max-h-[50px]">
                        <td class="border-b border-border px-4 py-4">
                            {{ 'shared.labels.company.industry_code' | transloco }}
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            {{ this.invoice?.company?.industry_code || '' }}
                        </td>
                    </tr>

                    <!-- Location -->
                    <tr class="max-h-[50px]">
                        <td class="border-b border-border px-4 py-4">
                            {{ 'admin.address' | transloco }}
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2 items-center">
                                <app-custom-dropdown [options]="locationsDropdownOptions"
                                    [showOnlyValueWhenDisabled]="true" [(selectedOption)]="selectedLocationDropdown"
                                    [disabled]="isEditing" boxHeight="h-[40px]" [disabled]="!isEditing"
                                    autoMarginTop="mt-0">
                                </app-custom-dropdown>

                                @if(isEditing)
                                {
                                <!-- Edit -->
                                <button title="{{ 'settings.button.edit' | transloco }}"
                                    class="p-1 rounded hover:bg-secondary-200"
                                    (click)="editLocation(getSelectedLocation())">
                                    <img src="assets/icons/edit.svg" alt="{{ 'settings.button.edit' | transloco }}"
                                        class="w-6 h-6" />
                                </button>

                                <!-- Create -->
                                <button title="{{ 'locations.add_new' | transloco }}"
                                    class="p-1 rounded hover:bg-secondary-200" (click)="editLocation()">
                                    <img src="assets/icons/add-black.svg" alt="{{ 'locations.add_new' | transloco }}"
                                        class="w-6 h-6" />
                                </button>
                                }
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</app-drop-down-section>